(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tcc-analytics", [], factory);
	else if(typeof exports === 'object')
		exports["tcc-analytics"] = factory();
	else
		root["tcc-analytics"] = factory();
})(self, () => {
return 